<ng-container *ngIf="stepId && hasError() | async">
  <div
    [ngClass]="{
      'trigger-error-disclaimer': isTrigger,
      'step-error-disclaimer': !isTrigger
    }"
    *ngIf="getErrorMessage() | async as errorMessage"
  >
    <glxy-alert type="error" *ngIf="!!errorMessage">
      <span [innerHTML]="errorMessage | iTrustThisHtml"></span>
    </glxy-alert>
  </div>
</ng-container>
